import React from "react";

import { copy } from "shared/assets";
import { Close } from "shared/assets/icons";
import { Icon } from "shared/styles";
import { VisuallyHiddenElement } from "shared/styles/constants";
import { StyledCloseButton, StyledCloseButtonProps } from "./styles";

interface CloseButtonProps extends StyledCloseButtonProps {
  onClick: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = (props) => (
  <StyledCloseButton type="button" {...props}>
    <Icon as={Close} />
    <VisuallyHiddenElement>{copy.a11y.close}</VisuallyHiddenElement>
  </StyledCloseButton>
);
